import { render, staticRenderFns } from "./ExamAnswerDetail.vue?vue&type=template&id=49ce6bde&scoped=true&"
import script from "./ExamAnswerDetail.vue?vue&type=script&lang=js&"
export * from "./ExamAnswerDetail.vue?vue&type=script&lang=js&"
import style0 from "./ExamAnswerDetail.vue?vue&type=style&index=0&id=49ce6bde&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ce6bde",
  null
  
)

export default component.exports